import { StatusPip, Tile } from '@diwata/ironvale'
import type { HealthFeed } from '@/api/feeds'
import { UnavailableNote, worstItemStatus } from './shared'

/** Prod + staging probes: status, latency, schema currency. */
export function HealthTile({ feed }: { feed: HealthFeed }) {
  const status = worstItemStatus(feed, (feed.items ?? []).map((i) => i.status))
  return (
    <Tile title="Health" status={status} asOf={feed.asOf}>
      {feed.status === 'unavailable' ? (
        <UnavailableNote feed={feed} />
      ) : (
        <div className="ap-tile-rows">
          {feed.items.map((item) => (
            <a key={item.name} className="ap-tile-row" href={item.link} target="_blank" rel="noreferrer">
              <StatusPip status={item.status === 'ok' ? 'ok' : item.status} label={`${item.name} ${item.status}`} />
              <span className="ap-row-name">{item.name}</span>
              <span className="ap-row-value">
                {item.error ? item.error : item.schema && item.schema !== 'current' ? `schema ${item.schema}` : 'ok'}
              </span>
              <span className="ap-row-meta ap-mono">{item.latency_ms}ms</span>
            </a>
          ))}
        </div>
      )}
    </Tile>
  )
}
